import { render, staticRenderFns } from "./CheckUpdatesBackModal.vue?vue&type=template&id=63cfb2a4"
import script from "./CheckUpdatesBackModal.vue?vue&type=script&lang=js"
export * from "./CheckUpdatesBackModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports